import { ImHtmlFive2 } from 'react-icons/im';
import {
  SiExpress,
  SiMongodb,
  SiTailwindcss,
  SiRedux,
  SiAntdesign,
  SiTypescript
} from 'react-icons/si';
import { TbBrandJavascript } from 'react-icons/tb';
import { DiJavascript } from 'react-icons/di';
import {
  FaReact,
  FaNodeJs,
  FaJava,
  FaGithub,
  FaCss3Alt,
  FaGitAlt,
} from 'react-icons/fa';

export const FrontEndSkills = [
  { name: 'HTML5', icon: <ImHtmlFive2 /> },
  { name: 'CSS3', icon: <FaCss3Alt /> },
  { name: 'JavaScript', icon: <DiJavascript /> },
  { name: 'TypeScript', icon: <SiTypescript /> },
  { name: 'ReactJS', icon: <FaReact /> },
  { name: 'Redux', icon: <SiRedux /> },
  { name: 'Tailwind CSS', icon: <SiTailwindcss /> },
  { name: 'Ant Design', icon: <SiAntdesign /> },
  { name: 'NodeJS', icon: <FaNodeJs /> },
  { name: 'ExpressJS', icon: <SiExpress /> },
  { name: 'MongoDB', icon: <SiMongodb /> },
  { name: 'Java', icon: <FaJava /> },
  { name: 'Git', icon: <FaGitAlt /> },

];

